import { DataObject } from "../utils/typeAssert.util";
import { ModifiedWebSocket } from "../utils/websocketModifier.util";
import { ModelResolver } from "../modelResolvers";
import { FunctionResolverFunction, IResolverStatic, Resolver } from "../types";
import { IdResolver } from "../idResolvers";

export abstract class FunctionResolver extends Resolver {
	protected options: {
		session: ModifiedWebSocket;
		sendMessage: (message: any) => Promise<void>;
		deSerializeObject: ModelResolver["deserialize"];
		serializeObject: ModelResolver["serialize"];
		uuid: IdResolver["gen"];
	};

	constructor(options: {
		session: ModifiedWebSocket;
		sendMessage: (message: any) => Promise<void>;
		deSerializeObject: ModelResolver["deserialize"];
		serializeObject: ModelResolver["serialize"];
		uuid: IdResolver["gen"];
	}) {
		super();
		this.options = options;
	}

	public abstract onMessage(message: DataObject): Promise<void> | void;

	public abstract setOurs(executor: Function, id?: string): Promise<string>;

	public abstract getOurs(id: string): Promise<Function | null>;

	public abstract setTheirs(id: string): Promise<FunctionResolverFunction>;

	public abstract getTheirs(
		id: string,
	): Promise<FunctionResolverFunction | null>;

	public abstract close(): void;
}

export interface IFunctionResolver extends IResolverStatic {
	new (options: {
		session: ModifiedWebSocket;
		sendMessage: (message: any) => Promise<void>;
		deSerializeObject: ModelResolver["deserialize"];
		serializeObject: ModelResolver["serialize"];
		uuid: IdResolver["gen"];
	}): FunctionResolver;
}
